import axios from "axios";

export default async function login({ formData }) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axios
    .post(`${process.env.REACT_APP_URL}/api/auth/signin`, formData, config)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err.response ? err.response.data : err.message;
    });
}

export function logout() {
  localStorage.removeItem("token");
  window.location.href = "/login";
}
